export const TEXTS = {
  MODAL_TITLE: 'Обновление условий оферты ',
  MODAL_TEXT: 'Сообщаем об изменениях, внесенных в условия оферты. Ознакомиться с новой версией можно ',
  MODAL_LINK_ANCHOR: 'по ссылке',
  MODAL_CONFIRM_BUTTON: 'Ознакомлен',
};
